import { GET_BANNED_USERS, SET_USER_BANNED } from '../actions/types';

// keyed by uid rather than tracked per moderation-report row, because one author
// can own several rows split across the page, and because the report documents
// carry no ban field - a per-row boolean would silently vanish on refetch
const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_BANNED_USERS: {
      return { ...action.payload.bannedUsers };
    }
    case SET_USER_BANNED: {
      const { uid, ban } = action.payload;
      return { ...state, [uid]: { ...(state[uid] || {}), ...ban } };
    }
    default:
      return state;
  }
}
